"use client";
import Image from "next/image";
import Link from "next/link";
import { useEffect } from "react";
import { Col, Container, Row } from "reactstrap";
import HorizaontalMenu from "../Menu/horizontal";
import TopBar from "./widgets/TopBar";
import Search from "./widgets/search";
import ShoppingCart from "./widgets/shopping-cart";

interface header {
  display: string;
}

export default function Header({ display }: header) {
  useEffect(() => {
    const handleScroll = () => {
      const stickyHeader = document.getElementById("stickyHeader");
      if (!stickyHeader) return;

      const number =
        window.pageXOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;
      if (number >= 300) {
        if (window.innerWidth < 581) {
          stickyHeader.classList.remove("sticky");
        } else {
          stickyHeader.classList.add("sticky");
        }
      } else {
        stickyHeader.classList.remove("sticky");
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <>
      <header id="stickyHeader">
        <div className="mobile-fix-option"></div>
        <TopBar />
        <div className="layout-header2">
          <Container>
            <Row>
              <Col md="12" className="my-4">
                <div className="main-menu-block" style={{ width: "100%" }}>
                  <div className="menu-left">
                    <div className="logo-block">
                      <Link href="/">
                        <Image
                          src={`/images/logo/logo-light.png`}
                          alt="logo"
                          className="img-fluid"
                          width={270}
                          height={100}
                        />
                      </Link>
                    </div>
                  </div>
                  <div className="menu-right">
                    <Search />
                    <div style={{ display: "none" }}>
                      <ShoppingCart position="right" cartDisplay={display} />
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="category-header-2">
          <div className="custom-container">
            <Row>
              <Col>
                <div className="navbar-menu">
                  <div className="category-left">
                    <HorizaontalMenu />
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </header>
    </>
  );
}
